module.exports = __webpack_public_path__ + "media/assets/faria_products/SMARTPREP-de052710241f1505d16ceea782cacdc3ca944233d6e3065c00d6d769e3a04de5.png";